import InnerPageCode from './innerPageCode'
import TemplateMain from '../templateMain'
import { SLIDESHOWS } from '../../types'

export default function PageCode() {
  return (
    <TemplateMain
      g_section="code"
      htmlTitle="Code"
      linksTitle="Other Site Links"
      innerPage={<InnerPageCode />}
      g_sidebarKey="pageCode"
      g_slideshowKey={SLIDESHOWS.logos}
    />
  )
}
